module.exports = __webpack_public_path__ + "dc259e6c47def02a16420c03c2bcf94f.svg";